import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pageContext, breakpointUtil as breakpoint } from 'ctm-util-functions';
import { Button, SimpleFlexbox, Text, Icon } from 'ctm-components';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { experimentIdSelector } from 'ctm-selectors';
import { EditMyDetailsContainer } from '../edit_my_details';
import styles from './affixed_results_menu.css';

/**
 * Transition component for Dialog
 * @param {Object} props Component props
 * @return {Node} Slide Component
 */
const transition = (props) => {
    return <Slide direction="left" {...props} />;
};

/**
 * Affixed Results Menu and Dialog
 * @return {Node} AffixedResultsMenu Component
 */
class _AffixedResultsMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // eslint-disable-next-line react/no-unused-state
            breakpoint: pageContext.getProps().pageState.breakpoint,
            open: false,
            content: ''
        };
    }

    /**
     * Close the modal box if viewport is not XS or SM
     * @return {Object} new State for the component
     */
    static getDerivedStateFromProps() {
        if (!breakpoint.isOneOf(['xs', 'sm'])) {
            const newBreakpoint = pageContext.getProps().pageState.breakpoint;
            return {
                breakpoint: newBreakpoint,
                open: false,
                content: ''
            };
        }
        return null;
    }

    /**
     * Close Dialog and clear out content state
     */
    handleDialogClose = () => {
        this.setState({ open: false, content: '' });
    };

    /**
     * Set dialog state and what content to show
     * @param {String} content The dialog content state
     */
    showDialog = (content) => {
        this.setState({
            open: true,
            content
        });
    };

    /**
     * Show Refine Dialog Function
     */
    showRefineDialog = () => {
        this.showDialog('Refine');
    };

    /**
     * Show Edit Dialog Function
     */
    showEditDialog = () => {
        this.showDialog('Edit');
    };

    /**
     * Gets Refine Components from Schema with component builder for Dialog
     * @return {Node} Refine Components
     */
    getRefineContent = () => {
        const components = ['component_paymentFrequecyTogggle', 'component_displayToggle', 'component_coverTypeFilter', 'component_carExcessFilter', 'component_filterControlsAffixed'];
        return <>{pageContext.getProps().director.constructComponents(components)}</>;
    };

    /**
     * Gets Edit Components for Dialog
     * @return {Node} Edit Components
     */
    getEditContent = () => (
        <>
            <EditMyDetailsContainer />
            <SimpleFlexbox display="flex" margin="top">
                <Button
                    iconPosition="before"
                    variant="full_width"
                    icon="ctm_reload"
                    label="Back to Results"
                    UIComponent="btn_secondary_medium_semi_rounded"
                    onClick={this.handleDialogClose}
                />
            </SimpleFlexbox>
        </>
    );

    /**
     * Gets Edit Components for Dialog
     * @return {Function} Content functions for edit/refine
     */
    getDialogContent = () => {
        const { content } = this.state;
        if (!content) return null;
        return content === 'Edit' ? this.getEditContent() : this.getRefineContent();
    };

    /**
     * Get Results Dialog
     * @return {Node} Results Dialog Component
     */
    getResultsDialog = () => {
        const { open, content } = this.state;
        return (
            <Dialog fullScreen open={open} onClose={this.handleDialogClose} TransitionComponent={transition}>
                <SimpleFlexbox className={styles.header} display="flex">
                    <SimpleFlexbox display="flex" contentStart="xs">
                        <Button className={styles.close} onClick={this.handleDialogClose}>
                            <Icon variant="ctm_angle_left" size="xxxlarge" color="brand_primary" />
                        </Button>
                    </SimpleFlexbox>
                    <SimpleFlexbox className={styles.title} display="flex" xs={12} itemsCenter="xs" contentCenter="xs">
                        <Text size="xlarge" color="brand_base_120" label={content} />
                    </SimpleFlexbox>
                </SimpleFlexbox>
                <SimpleFlexbox margin="all">{this.getDialogContent()}</SimpleFlexbox>
            </Dialog>
        );
    };

    /**
     * Returns Affixed mobile menus
     * @return {Node} Mobile Menu Component
     */
    getMobileMenu = () => {
        const { availableResults, newMorInfo } = this.props;
        if (newMorInfo) {
            return <></>;
        }
        return (
            <SimpleFlexbox className={styles.container} display="flex" itemsCenter="xs" contentCenter="xs">
                <Button
                    className={styles.button}
                    icon="ctm_filter"
                    iconPosition="before"
                    UIComponent="btn_feature_3_medium_squared"
                    label="Refine results"
                    onClick={this.showRefineDialog}
                />
                <Button
                    className={styles.button}
                    icon="ctm_pencil"
                    iconPosition="before"
                    UIComponent="btn_feature_3_medium_squared"
                    label="Edit my details"
                    onClick={this.showEditDialog}
                />
            </SimpleFlexbox>
        );
    };

    render = () => (
        <>
            {this.getMobileMenu()}
            {this.getResultsDialog()}
        </>
    );

}

_AffixedResultsMenu.propTypes = {
    availableResults: PropTypes.number,
    newMorInfo: PropTypes.bool
};

/**
 * Maps the store state to props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    const availableResults = state.getIn(['vertical', 'quote', 'results', 'payload', 'resultsMeta', 'availableCount']);
    const experimentId = experimentIdSelector(state);
    const newMorInfo = experimentId === 'splitNewResultMoreInfo';
    return {
        availableResults,
        newMorInfo
    };
};

const AffixedResultsMenu = connect(mapStateToProps)(_AffixedResultsMenu);

export { _AffixedResultsMenu, AffixedResultsMenu };
